
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SoakStyleDto } from './soaks.dto';


export class AllSoakStyleResponse extends GlobalResponseObject{
    data?: SoakStyleDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: SoakStyleDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}